import axios from "axios";
import ApiList from "services/apiList";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  data: {
    lessonId: -1,
    start: "08:00",
    end: "18:00",
  },
  schedule: {},
  scheduleLessons: {},
  shifts: [],
  courses: [],
  scheduleList: [],
  scheduleDetailList: [],

  error: "",
  loading: false,
};
// API CALL
export const fetchScheduleList = createAsyncThunk(
  "get/schedule_list",
  async () => {
    const response = await axios.get(ApiList.kindergartenScheduleUrl);
    return response.data;
  }
);
export const fetchScheduleDetailList = createAsyncThunk(
  "get/schedule_detail_list",
  async ({ id, currentDay }) => {
    const response = await axios.get(
      `${ApiList.kindergartenScheduleDetailUrl}?schedule=${id}&day=${currentDay}`
    );
    return response.data;
  }
);
export const fetchScheduleShifts = createAsyncThunk("get/shifts", async () => {
  const response = await axios.get(ApiList.shiftUrl);
  return response.data;
});
export const fetchScheduleCourses = createAsyncThunk(
  "get/courses",
  async () => {
    const response = await axios.get(ApiList.courseUrl);
    return response.data;
  }
);
export const fetchSchedule = createAsyncThunk("get/schedule", async (id) => {
  const response = await axios.get(`${ApiList.kindergartenScheduleUrl}${id}/`);
  return response.data;
});

export const fetchScheduleLessons = createAsyncThunk(
  "get/lessons",
  async () => {
    const response = await axios.get(ApiList.lessonUrl);
    return response.data;
  }
);

export const addSchedule = createAsyncThunk(
  "get/add_schedule",
  async (data) => {
    const response = await axios.post(ApiList.kindergartenScheduleUrl, data);
    return response.data;
  }
);
export const editSchedule = createAsyncThunk(
  "get/edit_schedule",
  async ({ id, data }) => {
    const response = await axios.put(
      `${ApiList.kindergartenScheduleUrl}${id}/`,
      data
    );
    return response.data;
  }
);
export const deleteSchedule = createAsyncThunk(
  "get/delete_schedule",
  async (id) => {
    const response = await axios.delete(
      `${ApiList.kindergartenScheduleUrl}${id}/`
    );
    return response.data;
  }
);

export const addScheduleDetail = createAsyncThunk(
  "get/add_scheduleDetail",
  async (data) => {
    const response = await axios.post(
      ApiList.kindergartenScheduleDetailUrl,
      data
    );
    return response.data;
  }
);

export const deleteScheduleDetail = createAsyncThunk(
  "get/delete_scheduleDetail",
  async ({ id }) => {
    const response = await axios.delete(
      `${ApiList.kindergartenScheduleDetailUrl}${id}/`
    );
    return response.data;
  }
);

// ACTIONS
const kindergartenScheduleSlice = createSlice({
  name: "kindergartenSchedule",
  initialState,
  reducers: {
    setErrorText: (state, action) => {
      state.error = action.payload;
    },
    setLessonId: (state, action) => {
      state.data.lessonId = action.payload;
    },
    setStart: (state, action) => {
      state.data.start = action.payload;
    },

    setEnd: (state, action) => {
      state.data.end = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder // COURSES
      .addCase(fetchScheduleCourses.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchScheduleCourses.fulfilled, (state, action) => {
        state.loading = false;
        state.courses = action.payload.result;
        state.error = "";
      })
      .addCase(fetchScheduleCourses.rejected, (state, action) => {
        state.loading = false;
        state.courses = [];
        state.error = action.error.message;
      }) // SHIFTS
      .addCase(fetchScheduleShifts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchScheduleShifts.fulfilled, (state, action) => {
        state.loading = false;
        state.shifts = action.payload.result;
        state.error = "";
      })
      .addCase(fetchScheduleShifts.rejected, (state, action) => {
        state.loading = false;
        state.shifts = [];
        state.error = action.error.message;
      }) // BUH HUWAARI
      .addCase(fetchScheduleList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchScheduleList.fulfilled, (state, action) => {
        state.loading = false;
        state.scheduleList = action.payload.result;
        state.error = "";
      })
      .addCase(fetchScheduleList.rejected, (state, action) => {
        state.loading = false;
        state.scheduleList = [];
        state.error = action.error.message;
      }) // SONGOGDSON HUWAARI
      .addCase(fetchSchedule.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.schedule = action.payload.result;
        state.error = "";
      })
      .addCase(fetchSchedule.rejected, (state, action) => {
        state.loading = false;
        state.schedule = {};
        state.error = action.error.message;
      })

      // LESSONS
      .addCase(fetchScheduleLessons.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchScheduleLessons.fulfilled, (state, action) => {
        state.loading = false;
        state.scheduleLessons = action.payload.result;
        state.data.lessonId = -1;
        state.error = "";
      })
      .addCase(fetchScheduleLessons.rejected, (state, action) => {
        state.loading = false;
        state.scheduleLessons = [];
        state.error = action.error.message;
      })

      // SCHEDULE NEMEH
      .addCase(addSchedule.pending, (state) => {
        state.loading = true;
      })
      .addCase(addSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(addSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // SCHEDULE ZASAH
      .addCase(editSchedule.pending, (state) => {
        state.loading = true;
      })
      .addCase(editSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(editSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      //SCHEDULE USTGAH
      .addCase(deleteSchedule.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSchedule.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(deleteSchedule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // SCHEDULE DETAIL AWAH
      .addCase(fetchScheduleDetailList.pending, (state) => {
        state.scheduleDetailList = [];
        state.loading = true;
      })
      .addCase(fetchScheduleDetailList.fulfilled, (state, action) => {
        state.loading = false;
        state.scheduleDetailList = action.payload.result;
        state.error = "";
      })
      .addCase(fetchScheduleDetailList.rejected, (state, action) => {
        state.loading = false;
        state.scheduleDetailList = [];
        state.error = action.error.message;
      })
      // SCHEDULE DETAIL NEMEH
      .addCase(addScheduleDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(addScheduleDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(addScheduleDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // SCHEDULE DETAIL USTGAH
      .addCase(deleteScheduleDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteScheduleDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
      })
      .addCase(deleteScheduleDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setErrorText, setRoomId, setLessonId, setStart, setEnd } =
  kindergartenScheduleSlice.actions;
export default kindergartenScheduleSlice.reducer;
